import deleteCompareModalConstants    from './deleteCompareModal.constants';
import deleteCompareModalInitialState from './deleteCompareModalInitial.state';

function deleteCompareModalReducer(state = deleteCompareModalInitialState, action) {
  switch (action.type) {
    case deleteCompareModalConstants.SHOW_MODAL:
      state = {
        open:         true,
        isSingleDoor: action.isSingleDoor || deleteCompareModalInitialState.isSingleDoor,
      };
      break;

    case deleteCompareModalConstants.HIDE_MODAL:
      state = { ...deleteCompareModalInitialState };
      break;

    default:
      state = { ...state };
  }

  return state;
}

export default deleteCompareModalReducer;